import { Link } from 'react-router-dom';

export function Download() {
  return (
    <div className="page">
      <header className="page__header">
        <p className="eyebrow">Install</p>
        <h1>Get from install to Architect in a few minutes.</h1>
        <p className="lede">
          DreamGraph v14.0.2 - Ashoka adds a shared Computer Use browser backend and context-cost fixes. The accepted platform scope remains maintainer Windows testing and the WSL2 Ubuntu installer/browser-worker test bed. The shortest path is: install,
          initialize one project, start the HTTP daemon, scan, and open Architect.
        </p>
      </header>

      <section className="install-card">
        <h2>1. Clone and install</h2>
        <p><a href="https://github.com/mmethodz/dreamgraph/releases/tag/v14.0.2">v14.0.2 release downloads and SHA-256 hashes</a>. Existing users: install and restart. Only graphs requiring legacy migration need an offline upgrade: stop that instance and run <code>dg graph-upgrade &lt;instance&gt;</code> with a reviewed backup, then restart and check health. Installation does not migrate data. See the <Link to="/guide/ashoka-upgrade">upgrade guide</Link> and <a href="/docs/ashoka/release-notes-v14.0.2.md">patch notes</a>.</p>
        <pre><code>{`git clone https://github.com/mmethodz/dreamgraph.git\ncd dreamgraph\n\n# Windows\nscripts/install.ps1 -Force\n\n# Linux / WSL2 test bed\nbash scripts/install.sh --force`}</code></pre>
        <p>Open a new terminal and run <code>dg --version</code>.</p>
      </section>

      <section className="install-card">
        <h2>2. Initialize your project</h2>
        <pre><code>{`cd path/to/your-project\ndg init --name my-app --project . --transport http\ndg start my-app --http\ndg scan my-app --depth deep`}</code></pre>
        <p>
          DreamGraph creates <code>plans/</code> automatically. Existing application files are not
          rewritten by the scan.
        </p>
      </section>

      <section className="install-card">
        <h2>3. Open the browser surfaces</h2>
        <pre><code>{`dg status my-app\n\nArchitect  http://127.0.0.1:8100/architect\nExplorer   http://127.0.0.1:8100/explorer/\nDashboard  http://127.0.0.1:8100/`}</code></pre>
        <p>Use the port reported by <code>dg status</code>. Config, Schedules, and Status are tabs in Architect. Its Open Explorer link launches a separate browser tab; the dashboard routes remain available directly.</p>
      </section>

      <section className="install-card">
        <h2>4. Connect Computer Use</h2>
        <p>The installer registers the native host. In Chrome or Edge, enable Developer mode on the extensions page and load the installed browser-extension folder unpacked. Check for <strong>Connected to DreamGraph</strong>, then choose your permission in Architect’s Config → Computer Use tab.</p>
        <pre><code>{`dg browser setup\ndg browser status`}</code></pre>
        <p><Link to="/guide/computer-use">Full browser installation and connection guide</Link> · <a href="https://github.com/mmethodz/dreamgraph/releases/download/v14.0.2/dreamgraph-browser-extension-14.0.2.zip">Browser extension ZIP</a> (extract before loading; matching runtime required).</p>
      </section>

      <section className="install-card install-card--accent">
        <h2>Use the Easy Start guide</h2>
        <p>
          It covers new projects, existing repositories, multi-repo systems, Codex CLI, Anthropic
          API setup, Architect’s operational tabs, Explorer, and troubleshooting.
        </p>
        <div className="hero__cta">
          <Link to="/guide/easy-start" className="btn btn--primary">Read online</Link>
          <a href="/docs/easy-start.md" className="btn btn--ghost">Markdown</a>
          <a href="/docs/easy-start.html" className="btn btn--ghost">HTML</a>
        </div>
      </section>
    </div>
  );
}
